import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ISSUE_TEMPLATE = `${TASK_SERVICE}/issue-templates`;

export const issueTemplates = {
  getAll: async ({ filters, sort, top, skip } = {}) => {
    const options = await apiOptions({
      url: `${API_ISSUE_TEMPLATE}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async (id) => {
    const options = await apiOptions({
      url: `${API_ISSUE_TEMPLATE}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_ISSUE_TEMPLATE,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ISSUE_TEMPLATE}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_ISSUE_TEMPLATE}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
